import { createSelector } from 'reselect'
import { getRequestData } from '@/logic/data/reducer'
import type { IHarvestSaleRequestData } from '@/services/HarvestSaleRequestService/interfaces'

export const getHarvestSaleRequest = createSelector(getRequestData<IHarvestSaleRequestData>('saleRequest'), ({ data }) => data?.current)
export const getHarvestSaleMultiRequest = createSelector(
  getRequestData<IHarvestSaleRequestData>('saleMultiRequest'),
  ({ data }) => data?.current,
)
